import {createApp} from 'vue'
import GroupSearchResult from './GroupSearchResult'

const el = '.kb-component--group-search-result'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((GroupSearchResultDOM)=>{
            const props = {
                source: GroupSearchResultDOM.dataset.source,
                hovedgruppekode: GroupSearchResultDOM.dataset.hovedgruppekode,
                guid: GroupSearchResultDOM.dataset.guid,
                spotCard: GroupSearchResultDOM.dataset.spotCard ? JSON.parse(GroupSearchResultDOM.dataset.spotCard) : null,
                skip: parseInt(GroupSearchResultDOM.dataset.skip) ?? 0,
                take: parseInt(GroupSearchResultDOM.dataset.take) ?? 10,
                disableInitialSearch: GroupSearchResultDOM.dataset.disableInitialSearch === 'true'
            }
            const component = createApp(GroupSearchResult, props).use(Store)
            component.mount(GroupSearchResultDOM)
        })
    }
}